import { Switch } from 'antd';
import React, { useEffect } from 'react';
import styled, { css } from 'styled-components';

import { addChangeListener } from 'stores/DynamicProperties/changeListeners';
import { type IDynamicProperty } from 'stores/DynamicProperties/IDynamicProperty';
import { useForceUpdate } from 'utils/Hooks';

const Container = styled.div<{ $changed: boolean }>`
    display: flex;
    align-items: center;
    margin-bottom: 7px;
    width: 190px;
    margin-right: 10px;

    ${(p) =>
        p.$changed &&
        css`
            > div {
                background: #e1f3ff;
            }
        `}
`;

const SwitchContainer = styled.div`
    border: 1px solid #d6d6d6;
    border-radius: 4px;
    padding: 0 6px;
    background: #ffffff;
    height: 32px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const BooleanSwitch = styled(Switch)`
    width: 100%;
`;

type SwitchInputProps = {
    disabled?: boolean;
    property: IDynamicProperty<any>;
};

// Not an observer, deliberately. Nothing read during render is observable: a
// leaf DynamicProperty never calls becomeObservable, and the only path that
// would make one observable - DynamicGroup.enableState - has no callers.
// Re-rendering comes entirely from the subscription below.
function SwitchInput({ disabled, property }: SwitchInputProps) {
    const forceUpdate = useForceUpdate();
    useEffect(
        () => addChangeListener(property, forceUpdate),
        [property, forceUpdate]
    );

    const handleInputChange = (checked: boolean) => {
        property.set(checked);
    };

    return (
        <Container $changed={property.getChanged()}>
            <SwitchContainer>
                <BooleanSwitch
                    checked={!!property.value}
                    onChange={handleInputChange}
                    disabled={disabled}
                />
            </SwitchContainer>
        </Container>
    );
}

export default SwitchInput;
